import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: () => ({
    mapZoom: 12,
    mapCenter: {
        lat: 0,
        lng: 0,
    },
    mapLoaded: false,
    selectedCourse: {
        checkPoints: [],
    },
    dataReady: false,
    markersDisplayed: false,
    selectedCheckPoint: null,
  }),
  getters: {
    checkPoints: state => state.selectedCourse.course_marks || [],
    accommodations: state => state.selectedCourse.accommodation_courses?.map(ac => ac.accommodation_data) || [],
  },
  mutations: {
    initStates: function(state, payload) {
    },
    setMapState: function(state, payload) {
        state.mapZoom = payload.mapZoom;
        state.mapCenter = payload.mapCenter;
    },
    setMapLoaded: function(state, loaded = true) {
        state.mapLoaded = loaded;
    },
    setDataReady: function(state, ready = true) {
        state.dataReady = ready;
    },
    markersDisplayed: function(state, displayed = true) {
        state.markersDisplayed = displayed;
    },
    setSelectedCourse: (state, course) => {
        state.selectedCourse = course;
    },
    setSelectedCheckPoint: (state, checkPoint) => {
        state.selectedCheckPoint = checkPoint;
    },
    setCheckPointIsClosed: (state, payload) => {
      payload.checkPoint.mark.isClosed = payload.isClosed;
    },
    setCheckPointNextOpenTime: (state, payload) => {
      payload.checkPoint.mark.nextOpenTime = payload.nextOpenTime;
    },
    setCheckPointNextOpenTimeString: (state, payload) => {
      payload.checkPoint = Object.assign({}, payload.checkPoint, {
        mark: Object.assign(payload.checkPoint.mark, {
          nextOpenTimeString: payload.nextOpenTimeString,
        }),
      });
    },
    checkPointsUpdate: (state, payload) => {
      if(state.selectedCourse?.checkPoints) state.selectedCourse.checkPoints.splice(0, 0);
      console.log('checkPointsUpdate checkPoints: ', state.selectedCourse.checkPoints);
    },
    updateVisitRecord: (state, payload) => {
      Object.assign(payload.destRecord, payload.sourceRecord);
      console.log('updateVisitRecord destRecord, sourceRecord: ', payload.destRecord, payload.sourceRecord);
    },
    sortVisits: (state, visits) => {
      if(visits.length < 2) return;
      visits.sort((a, b) => {
        return moment(a.date).isAfter(b.date);
      });
    },
    deleteVisitRecord: (state, payload) => {
      payload.checkPoint.visits = payload.checkPoint.visits.filter(visit => visit.id !== payload.visitRecordToDelete.id);
    },
  },
  strict: debug,
})